export default __webpack_public_path__ + "5ac188463a0bf78b33517d5623fcc781.otf";